export const SampleOrders = () => {
  return (
    <div>
      <h1>Orders</h1>
    </div>
  )
}
